// extracted by mini-css-extract-plugin
export default {"container":"Project_container__qHMdT","wrapper":"Project_wrapper__tP65K","wizard":"Project_wizard__8jYU5"};